export default "__VITE_ASSET__afAgmHYb__"